"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookUsageType = void 0;
exports.WebhookUsageType = {
    ConvAiAgentSettings: "ConvAI Agent Settings",
    ConvAiSettings: "ConvAI Settings",
    VoiceLibraryRemovalNotices: "Voice Library Removal Notices",
    SpeechToText: "Speech to Text",
};
